import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { IconSvg } from 'shared/icon';
import { LocalStorageService } from 'services';
import { useGetSystemConversionsResourceQuery } from 'app/systemConversion/api';
import { setCurrentConversionId } from 'app/userPreferences/slices';

import { selectCurrentConversionId } from 'app/userPreferences/selectors';
import { Current } from 'app/userPreferences/types';
import {
  StyledHeaderSelectClose, StyledHeaderSelectToggle, StyledHeaderSelectWrapper, StyledSystemConversion,
} from 'app/layout/components/Layout.styled';
import { AdminSelect } from 'shared/formControl';

export interface SystemConversionsProp{
  showConversion?: boolean
}

const SystemConversions = ({ showConversion = false }:SystemConversionsProp) => {
  const [open, setOpen] = useState(false);

  const { colors } = useTheme();

  const { data: systemConversions } = useGetSystemConversionsResourceQuery();

  const conversionId = useAppSelector(selectCurrentConversionId);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (systemConversions?.length) {
      const current = LocalStorageService.get<Current>('current') || {};

      let id = current?.conversionId;
      if (!id) {
        id = systemConversions.find(({ isDefault }) => isDefault)?.id;
      }
      dispatch(setCurrentConversionId(id));

      LocalStorageService.set('current', {
        ...current,
        conversionId: id,
      });
    }
  }, [systemConversions, dispatch]);

  const openDropDown = () => {
    setOpen(true);
  };

  const closeDropDown = () => {
    setOpen(false);
  };

  const conversionChange = (id: string) => {
    const currentData = LocalStorageService.get('current') || {};

    LocalStorageService.set('current', {
      ...currentData,
      conversionId: id,
    });

    dispatch(setCurrentConversionId(id));
    closeDropDown();
  };

  return (
    !!systemConversions?.length
    && showConversion && (
      <div>
        <StyledHeaderSelectToggle onClick={openDropDown}>
          <IconSvg icon="ManageCurrencyIcon" width="1.4rem" height="1.4rem" color={colors.white} />
        </StyledHeaderSelectToggle>
        <StyledHeaderSelectWrapper $isOpen={open}>
          <StyledSystemConversion>
            <AdminSelect
              onChange={conversionChange}
              value={conversionId}
              allowClear={false}
              data={systemConversions?.map((conversion) => ({
                id: conversion.id,
                name: conversion.id,
              }))}
              isToString={false}
              virtual={false}
            />
            <StyledHeaderSelectClose onClick={closeDropDown}>
              <IconSvg icon="CloseModalIcon" width="1.14rem" height="1.14rem" color={colors.white} />
            </StyledHeaderSelectClose>
          </StyledSystemConversion>
        </StyledHeaderSelectWrapper>
      </div>
    )
  );
};

export default SystemConversions;
